import type { FaireProductEntity } from "../../entity_types/product";

export const p_pajm5dfewq: FaireProductEntity = {
  token: "p_pajm5dfewq",
  type: "product",
  name: "YUZU PEPPER",
  brandToken: "b_djcfr54fi3",
  brandName: "MOMO dressing",
  imageUrl:
    "https://cdn.faire.com/fastly/58d899a197a153a4f15f764a28f212a74fdfb696cabf5b818319e84dc9270b5f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd43d1615cb4098a3f933317aa356bc32559ed812c5b314f169c90e62471b4e4.jpeg",
    "https://cdn.faire.com/fastly/74557f270b69d1b66401af2a8ca3fd19b6f16bd7c134bdda9d359c248341c6a6.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Our Yuzu pepper is made by our partner Yuzu farm in Oita prefecture, Japan.  Oita prefecture is the birthplace of Yuzu peppers and located in Kyushu Island.  The farm is Organic and has an Eco-farmer certification issued by the Japanese government. The peppers are grown by our partner farm, right next to their Yuzu.  Our Yuzu pepper has no preservatives at all. Yuzu pepper is ready to eat, no need to cook or heat up. Great with grilled chicken, sushi, sashimi, soup, noodles, any dishes!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:17.416Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
